import { BodyText } from 'styling/Typography'
import { SourceBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import { OpsEventSeverity } from 'types/operationsControl.interface'
import { ITimelineGroupRowProps } from 'types/opsTimeline.interface'
import { DEPARTMENT_LABEL, GROUP_KIND_PHRASE, KIND_LABEL } from './timelineMeta'
import { TimelineEventRow } from './TimelineEventRow'
import {
  DepartmentTag,
  DotCell,
  EventCard,
  EventRow,
  GroupAffordance,
  GroupChevron,
  GroupChildren,
  KindChip,
  MetaRow,
  SeverityDot,
  TimeCell,
  TitleRow,
} from './OpsTimeline.styled'

const SEVERITY_RANK: { [k in OpsEventSeverity]: number } = {
  critical: 0,
  warning: 1,
  info: 2,
  success: 3,
}

export const TimelineGroupRow = ({ group, expanded, onToggle }: ITimelineGroupRowProps) => {
  const first = group.events[0]
  const count = group.events.length
  const worst = group.events.reduce<OpsEventSeverity>(
    (acc, e) => (SEVERITY_RANK[e.severity] < SEVERITY_RANK[acc] ? e.severity : acc),
    first.severity,
  )
  const sharedDescription = group.events.every((e) => e.description === first.description)
    ? first.description
    : null
  const context = sharedDescription || (first.department ? DEPARTMENT_LABEL[first.department] : null)
  const phrase = GROUP_KIND_PHRASE[first.kind] || 'events'
  const title = context ? `${count} ${phrase} — ${context}` : `${count} ${phrase}`
  const sharedSource = group.events.every((e) => e.source === first.source) ? first.source : null

  return (
    <>
      <EventRow>
        <TimeCell>{group.time}</TimeCell>
        <DotCell>
          <SeverityDot $tone={worst} />
        </DotCell>
        <EventCard $clickable onClick={onToggle}>
          <TitleRow>
            <BodyText weight='600'>{title}</BodyText>
            <KindChip>{KIND_LABEL[first.kind]}</KindChip>
          </TitleRow>
          <GroupAffordance>
            <GroupChevron $expanded={expanded}>›</GroupChevron>
            {`+${count} events`}
          </GroupAffordance>
          {(sharedSource || first.department) && (
            <MetaRow>
              {sharedSource && <SourceBadge source={sharedSource} />}
              {first.department && <DepartmentTag>{DEPARTMENT_LABEL[first.department]}</DepartmentTag>}
            </MetaRow>
          )}
        </EventCard>
      </EventRow>
      {expanded && (
        <GroupChildren>
          {group.events.map((e) => (
            <TimelineEventRow key={e.id} event={e} />
          ))}
        </GroupChildren>
      )}
    </>
  )
}
